/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import { string, number, date, array, object } from './utils'

export const putsavePageItem = {
  Req: {
    "moduleName": {
        "type": String,
        "required": true
    },
    "moduleCode": {
        "type": String,
        "required": true
    },
    "pageName": {
        "type": String,
        "required": true
    },
    "pageCode": {
        "type": String,
        "required": true
    },
    "groupName": {
        "type": String,
        "required": true
    },
    "groupCode": {
        "type": String,
        "required": true
    },
    "groupType": {
        "type": String,
        "required": true
    },
    "groupPatchList": {
        "type": Array,
        "required": true
    },
    "groupPatchList[0]": {
        "type": Object,
        "required": true
    },
    "groupPatchList[0].groupPatchId": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].patchCode": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].patchName": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].listItemList": Array,
    "groupPatchList[0].listItemList[0]": {
        "type": Object,
        "required": true
    },
    "groupPatchList[0].listItemList[0].itemId": String,
    "groupPatchList[0].listItemList[0].itemPropertie": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].listItemList[0].itemTitle": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].listItemList[0].itemWidth": Number,
    "groupPatchList[0].listItemList[0].itemMinWidth": Number,
    "groupPatchList[0].listItemList[0].activeState": {
        "type": Number,
        "required": true
    },
    "groupPatchList[0].formItemList": Array,
    "groupPatchList[0].formItemList[0]": {
        "type": Object,
        "required": true
    },
    "groupPatchList[0].formItemList[0].itemId": String,
    "groupPatchList[0].formItemList[0].itemPropertie": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].formItemList[0].itemTitle": {
        "type": String,
        "required": true
    },
    "groupPatchList[0].formItemList[0].itemWidth": Number,
    "groupPatchList[0].formItemList[0].itemReadOnly": {
        "type": Number,
        "required": true
    },
    "groupPatchList[0].formItemList[0].itemRequired": {
        "type": Number,
        "required": true
    },
    "groupPatchList[0].formItemList[0].activeState": {
        "type": Number,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetTipsList = {
  Req: {
    "pageCode": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsaveTips = {
  Req: {
    "moduleCode": {
        "type": String,
        "required": true
    },
    "moduleName": {
        "type": String,
        "required": true
    },
    "pageCode": {
        "type": String,
        "required": true
    },
    "pageName": {
        "type": String,
        "required": true
    },
    "tipsTitle": {
        "type": String,
        "required": true
    },
    "tipsContent": {
        "type": String,
        "required": true
    },
    "tipsType": {
        "type": Number,
        "required": true
    },
    "activeState": {
        "type": Number,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putupdateTips = {
  Req: {
    "tipsInfoId": {
        "type": String,
        "required": true
    },
    "tipsTitle": {
        "type": String,
        "required": true
    },
    "tipsContent": {
        "type": String,
        "required": true
    },
    "tipsType": {
        "type": Number,
        "required": true
    },
    "activeState": {
        "type": Number,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deletedeleteTips = {
  Req: {
    "linkId": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postresetSystemSettings = {
  Req: {
    "type": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putorder = {
  Req: {
    "linkId1": {
        "type": String,
        "required": true
    },
    "linkId2": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postsaveText = {
  Req: {
    "textType": {
        "type": String,
        "required": true
    },
    "textCode": {
        "type": String,
        "required": true
    },
    "textContent": {
        "type": String,
        "required": true
    },
    "activeState": {
        "type": Number,
        "required": true
    },
    "moduleName": {
        "type": String,
        "required": true
    },
    "moduleCode": {
        "type": String,
        "required": true
    },
    "pageName": {
        "type": String,
        "required": true
    },
    "pageCode": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putupdateText = {
  Req: {
    "pageTextId": {
        "type": String,
        "required": true
    },
    "textType": {
        "type": String,
        "required": true
    },
    "textCode": {
        "type": String,
        "required": true
    },
    "textContent": {
        "type": String,
        "required": true
    },
    "activeState": {
        "type": Number,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deletedeleteText = {
  Req: {
    "pageTextIds": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetTextList = {
  Req: {
    "pageCode": {
        "type": String,
        "required": true
    },
    "textType": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSettingList = {
  Req: {
    "groupCode": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSystemDefault = {
  Req: {
    "groupCode": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getexportSettings = {
  Req: {
    "type": {
        "type": Array,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}